import { useState } from 'react';
import PropTypes from 'prop-types';

import { FaTimes } from 'react-icons/fa';

import { addHashToHexColor, getsessionStorageData } from '../../lib';
import { sessionStorageKeys } from '../../constants';

import './OfferPopup.css';

const OfferPopup = ({
    props: {
        popupTopImage: imageUrl,
        topImageHeight,
        popupTitle: title,
        popupText: desc,
        popupButton1Text: btnText,
        popupButton1Link: btnUrl,
        popupID,
        popupWidth,
        popupHeight,
        popupBorderRadius,
        popupBorderColor,
        popupBackgroundColor,
        popupVerticalAlign = 'top',
        popupHorrizontalAlign = 'left',

        popupCloseButtonColor,
        popupCloseButtonBackgroundColor,

        popupButton1Background,
        popupButton1FontColor,
        popupButton1BorderColor,
        popupButton1FontSize,
        popupButtonStyle,
        popupOpenInterval,

        popupButton2Text,
        popupButton2Link,
        popupButton2FontColor,
        popupButton2Background,
        popupButton2BorderColor,
        popupButton2FontSize,

        popupBackgroundImage,
        imageTopMargin: topMargin,
        popupBottomMargin: bottomMargin,
        popupLeftMargin: leftMargin,
        popupRightMargin: rightMargin,
    },
    extraClass = '',
}) => {
    const closedOfferPopups = getsessionStorageData(
        sessionStorageKeys.CLOSED_OFFER_POPUPS,
        []
    );

    let initialState;

    if (popupOpenInterval === 'Everytime') {
        initialState = true;
    } else {
        initialState = closedOfferPopups.indexOf(popupID) === -1;
    }

    const [isOpen, setIsOpen] = useState(initialState);

    const closePopup = () => {
        if (
            closedOfferPopups.indexOf(popupID) === -1 &&
            popupOpenInterval !== 'Everytime'
        ) {
            closedOfferPopups.push(popupID);
            sessionStorage.setItem(
                sessionStorageKeys.CLOSED_OFFER_POPUPS,
                JSON.stringify(closedOfferPopups)
            );
        }
        setIsOpen(false);
    };

    let positionClass = '';

    if (popupVerticalAlign && popupHorrizontalAlign) {
        positionClass = `ab-offer-popup-cnt--${popupVerticalAlign
            .toLocaleLowerCase()
            .replace('middle', 'center')}-${popupHorrizontalAlign
            .toLocaleLowerCase()
            .replace('middle', 'center')}`;
    }

    const popupCntStyles = {
        backgroundColor: addHashToHexColor(popupBackgroundColor),
        borderColor: addHashToHexColor(popupBorderColor),
        height: popupHeight,
        width: popupWidth,
        marginTop: topMargin,
        marginBottom: bottomMargin,
        marginLeft: leftMargin,
        marginRight: rightMargin,
    };

    const popupInnerCntStyles = {
        borderRadius: popupBorderRadius,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundImage:
            'url(' +
            `https://hotelmanager.abouthotelier.com/${popupBackgroundImage}` +
            ')',
    };

    // const popupCloseBtnStyles = {
    //     backgroundColor: addHashToHexColor(popupCloseButtonBackgroundColor),
    //     color: addHashToHexColor(popupCloseButtonColor),
    // };

    const popupLinkStyles = {
        backgroundColor: addHashToHexColor(popupButton1Background),
        borderColor: addHashToHexColor(popupButton1BorderColor),
        color: addHashToHexColor(popupButton1FontColor),
        fontSize: addHashToHexColor(popupButton1FontSize),
    };

    const popupLinkStyles2 = {
        backgroundColor: addHashToHexColor(popupButton2Background),
        borderColor: addHashToHexColor(popupButton2BorderColor),
        color: addHashToHexColor(popupButton2FontColor),
        fontSize: addHashToHexColor(popupButton2FontSize),
    };

    return (
        isOpen && (
            <div
                className={`ab-offer-popup-cnt ${positionClass} ${extraClass}`}
                style={popupCntStyles}
            >
                <button
                    className="ab-offer-popup-close-btn"
                    // style={popupCloseBtnStyles}
                    onClick={closePopup}
                >
                    <FaTimes />
                </button>

                <div className="ab-offer-popup-inner-cnt">
                    {imageUrl && (
                        <div className="ab-offer-popup-header">
                            <div className="ab-offer-popup-image">
                                <img src={imageUrl} alt="" />
                            </div>
                        </div>
                    )}

                    <div
                        className="ab-offer-popup-body"
                        style={popupInnerCntStyles}
                    >
                        <h4
                            className="ab-offer-popup-title"
                            dangerouslySetInnerHTML={{ __html: title }}
                        ></h4>
                        <div
                            className="ab-offer-popup-desc"
                            dangerouslySetInnerHTML={{ __html: desc }}
                        ></div>
                        {}
                        {popupButtonStyle !== 'No Buttons' && (
                            <>
                                <a
                                    className="ab-offer-popup-link"
                                    href={btnUrl}
                                    target="_blanck"
                                    rel="noopener noreferrer"
                                    style={popupLinkStyles}
                                >
                                    <span>{btnText}</span>
                                </a>
                                {popupButtonStyle === '2 Buttons' && (
                                    <a
                                        className="ab-offer-popup-link ab-offer-popup_link2"
                                        href={popupButton2Link}
                                        target="_blanck"
                                        rel="noopener noreferrer"
                                        style={popupLinkStyles2}
                                    >
                                        <span>{popupButton2Text}</span>
                                    </a>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    );
};

// TODO: MAKE THIS BETTER
OfferPopup.propTypes = {
    props: PropTypes.object,
    imageUrl: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    btnText: PropTypes.string,
    btnUrl: PropTypes.string,
    extraClass: PropTypes.string,
};

export default OfferPopup;
